import React, { ReactElement, ReactNode } from 'react';
import { StepProgressBar } from '@components/StepProgressBar';
import classNames from 'classnames';
import { ExtendedFlowT } from 'types/flow';

import { AssistedBar } from './AssistedBar';

import styles from './StepFooter.module.scss';

export interface StepFooterButtonI {
  onClick: () => void;
  text: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  hideOnMobile?: boolean;
}

export interface StepFooterPropsI {
  continueBtn?: StepFooterButtonI;
  backBtn?: StepFooterButtonI;
  className?: string;
  flow?: ExtendedFlowT;
  assistedBy?: ReactNode;
}

const StepFooter = ({
  continueBtn,
  backBtn,
  className,
  flow,
  assistedBy,
}: StepFooterPropsI): ReactElement => {
  const containerClassNames = classNames(styles.step_footer_main, className, {
    ['container_border']: !flow,
  });
  const currentStep =
    flow?.currentStep === 1 || flow?.currentStep === undefined ? 1 : flow?.currentStep;

  return (
    <>
      <StepProgressBar
        currentStep={currentStep}
        showBackButton
        onBack={backBtn?.onClick}
        textOnBackButton={backBtn?.text ?? 'Volver'}
        onContinue={continueBtn?.onClick}
        textOnContinueButton={continueBtn?.text ?? 'Continuar'}
        steps={flow?.steps ?? 8}
        subtitle={flow?.missingStepsText ?? ''}
        disabled={continueBtn?.isDisabled}
        loading={continueBtn?.isLoading}
        containerClassName={containerClassNames}
        customBottomBar={!!assistedBy && <AssistedBar name={assistedBy} />}
      />
    </>
  );
};

export default StepFooter;
